export const environment = {
  production: false,

  baseUrl: "https://stag.nurture.farm/afs/",
  unimartBaseUrl: "https://stag.nurture.farm/unimart/",
  farmerAppBaseURL: "https://stag.nurture.farm/afs-farmer-app/",
  rsBaseUrl: "https://stag.nurture.farm/afs-rs/",
  s3_bucket_client: "afs-qa-client",
  s3_bucket: "afs-server-qa",
  farmerAppClientKey: "mdm-server",
  farmerAppClientSecret: "u6I831g3rs7XyPZSPIHMgCxSi6FBBdEYDtSQcd7R",
  mapsPortalUrl: "https://maps.stag.nurture.farm/",
  retailDbAthena: "ecommerce_test",
  farmDbAthena: "stage_afsdb",
  partnerDbAthena: "pms",
  firebaseConfig: {
    apiKey: "AIzaSyB4oyD8IdsiwVDvZq6ZQxBAv5PSDG9N4F0",
    authDomain: "farm-mdm.firebaseapp.com",
    projectId: "farm-mdm",
    storageBucket: "farm-mdm.appspot.com",
    messagingSenderId: "231936911250",
    appId: "1:231936911250:web:af7ca1376d92235622834b",
    measurementId: "G-EX7FEDFYG4",
  },
  CampaighnTemplateClientId:'template-management-service',
  CampaighnTemplateClientSecretId:'fBywrGPbSfLYuJzqwPDr',
  aws_cms: {
    S3_BUCKET: "content-management-service-stage",
    S3_REGION: "ap-south-1"
  },
  mapApiKey: "AIzaSyAvD_cQBcfxVkcXjakTCl64gnmLdsq7WbE",
  aws_credentials: {
    AWS_REGION: "ap-south-1"
  },
};
